<template>
    <modal-helper v-show="isVisible" @close="close" title="Report Summary">
        <template v-slot:body>
            <section class="display-summary-container">   
                <table-results-helper>
                        <template v-slot:table>
                            <table class="table table-striped table-sm">
                                <thead>
                                    <tr class="right-aligned">
                                        <th scope="col">Cases</th>
                                        <th scope="col">Total Notes</th>
                                        <th scope="col">Internal notes</th>
                                        <th scope="col">External Notes</th>
                                        <th scope="col">Total Attachments</th>      
                                        <th scope="col">Missing Attachments</th>                        
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-if="summaryData">
                                        <tr class="right-aligned">
                                            <td>{{ summaryData.cases }}</td>
                                            <td>{{ summaryData.totalNotes }}</td>
                                            <td>{{ summaryData.internalNotes }}</td>
                                            <td>{{ summaryData.externalNotes }}</td>
                                            <td>{{ summaryData.attachments }}</td>
                                            <td>{{ summaryData.missingAttachments }}</td>
                                        </tr>                          
                                    </template>
                                </tbody>
                            </table>
                        </template>
                </table-results-helper>
            </section>
        </template>
        <template v-slot:footer>
            <button
            class="btn btn-block btn-success"
            @click="generateReport">
            Generate Report
        </button>
        </template>
    </modal-helper>
</template>

<script>
import ModalHelper from '../components/helpers/ModalHelper.vue';
import TableResultsHelper from './helpers/TableResultsHelper.vue';

export default {
    components: {
        'table-results-helper': TableResultsHelper,
        'modal-helper': ModalHelper,
    },
    props: ['summaryData', 'isVisible'],
    methods: {
        close() {
            this.$emit('close');
        },
        generateReport() {
            this.$emit('generateReport');
        },
    },
};
</script>

<style lang="scss" scoped>
  .display-summary-container {
      display: flex;
      flex-direction: column;
      margin-bottom: var(--global-gutter-size);
      width: 100%;
      .centered {
          text-align: center;
      }
      .message {
          color: var(--global-secondary-font-color);
          font-size: 0.875rem;
      }
  }
  .right-aligned {
       text-align: right;
  }
</style>
